import Choices from 'choices.js';

class Select {
  el: any;
  instance: any = null;
  options: any = {
    itemSelectText: '',
  };

  constructor(el: any, options: any) {
    this.el = el;
    this.options = options ? options : this.options;
    this.instantiate(this.el, this.options);
  }

  private instantiate(el: any, options: any) {
    this.instance = new Choices(el, {
      ...options,
    });
  }
}

export default Select;
